import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { PortalBaseService } from 'src/portal/portal-base.service';
import { MessageContent, ResultModel } from './messages.models';

@Injectable({
  providedIn: 'root'
})
export class MessagesService extends PortalBaseService {
  public getMessages(
    pageIndex: number,
    pageSize: number,
    messageType: string = null
  ): Promise<ResultModel> {
    const messageTypeQuery = messageType ? `messageType=${messageType}` : '';
    return lastValueFrom(
      this.get<ResultModel>(
        `portal/messages?pageIndex=${pageIndex}&&pageSize=${pageSize}&&${messageTypeQuery}`
      )
    );
  }
  public getMessageById(id: string): Promise<MessageContent> {
    return lastValueFrom(this.get<MessageContent>(`portal/messages/${id}/content`));
  }
}
